module.exports = __webpack_public_path__ + "assets/img/avatar.5314ae16.png";